// extracted by mini-css-extract-plugin
module.exports = {"root":"MessageBoxIcon-root-82e7efca7a9a18187b1fb1581629a3af"};